import { render, staticRenderFns } from "./existing-company.vue?vue&type=template&id=482ede2c&"
import script from "./existing-company.vue?vue&type=script&lang=js&"
export * from "./existing-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports